import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import DownloadApp from '@/controller/downloadApp/downloadApp'
import 'antd/dist/antd.less'

function App() {
  // const res = request.get('' , {data} , header)
  useEffect(() => {
    return () => {
    };
  }, []);
  return (
    <>
       <DownloadApp />
    </>
  );
}

export default App;
